import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import MapSection from '../components/MapSection';

const NeedToKnowSection = props => {
  const {
    languageData,
    coordinatesForMapCenter,
    spacesDataFromBackend,
    onClickMarkers,
    spaceData,
  } = props;

  const defaultText =
    languageData === 'EN'
      ? 'Stylish and low-key, with Santa María soul. Textured walls, soft lighting, and café-like comfort set the mood. Located steps from the Kiosco Morisco. Ergonomic chairs, fast Wi-Fi, and a gallery-worthy table made for deep work and creative chats.'
      : 'Estiloso y discreto, con alma de Santa María. Paredes con textura, iluminación suave y la comodidad de un café marcan la atmósfera. Ubicado a pasos del Kiosco Morisco. Sillas ergonómicas, Wi-Fi rápido y una mesa pensada para trabajo profundo y charlas creativas.';

  const needToKnowText =
    languageData === 'EN'
      ? spaceData?.need_to_know_en?.trim()
        ? spaceData.need_to_know_en
        : defaultText
      : spaceData?.need_to_know?.trim()
        ? spaceData.need_to_know
        : defaultText;

  return (
    <FlexContainer className="bgGradientReviewBlue180 borderrad14 pad20 flex-column width100">
      <Label className="text-18 margb16" style={{ fontWeight: 700 }}>
        {languageData === 'EN' ? 'Need to Know' : 'Información Importante'}
      </Label>

      <Label
        className="text-13 margb20"
        style={{
          fontWeight: 600,
          opacity: 0.9,
          lineHeight: '1.6',
        }}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: needToKnowText,
          }}
        />
      </Label>

      <MapSection
        spaceData={spaceData}
      />
    </FlexContainer>
  );
};

export default NeedToKnowSection;
